import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '黑料社区',
          url: 'https://heiliao.community',
          description: '黑料社区是网络热门爆料与深度挖掘的核心聚集平台，汇聚最新明星黑料、娱乐圈内幕、网红翻车事件及各类独家爆料内容。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://heiliao.community/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '黑料社区',
          url: 'https://heiliao.community',
          description: '网络热门爆料与深度挖掘的核心聚集平台',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'tips@heiliao.community',
            contactType: 'customer service',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '黑料社区 - 最新爆料聚集地',
          url: 'https://heiliao.community',
          description: '黑料社区是网络热门爆料与深度挖掘的核心聚集平台，汇聚最新明星黑料、娱乐圈内幕、网红翻车事件及各类独家爆料内容。',
          isPartOf: {
            '@type': 'WebSite',
            name: '黑料社区',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <HotArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}